module.exports = {"id":"dp4_1l1q2","text":"Protecting Devices","instructions":"Which statement best describes how devices are kept secure?","groupTitle":"Digital Profiler Knowledge Matrix","multiselect":false,"category":"4.1","questionType":"PickOne","random":true,"options":[{"id":"dp4_1l1q2-a1","text":"People and tools work together","score":1.8},{"id":"dp4_1l1q2-a2","text":"Security tools work automatically","score":0},{"id":"dp4_1l1q2-a3","text":"Devices protect themselves","score":0}]}


//////////////////
// WEBPACK FOOTER
// ./src/constants/dp/questions/cat4.1/l1q2.json
// module id = 1203
// module chunks = 41